import React, { Component } from 'react';
import { Grid, Row, Col, Button } from 'react-bootstrap';

import Card from 'components/Card/Card.jsx';

import Form from 'react-jsonschema-form';
import SweetAlert from 'react-bootstrap-sweetalert';

//Redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as OperatorsActions from './redux/OperatorsActions';
import widgets from '../../lib/widgets';

import auth from '../../libCustom/auth';

const schema = {
  $id: 'http://example.com/example.json',
  type: 'object',
  definitions: {},
  $schema: 'http://json-schema.org/draft-07/schema#',
  required: ['name', 'tipo'],
  properties: {
    name: {
      $id: '/properties/name',
      type: 'string',
      default: '',
      title: 'Nombre',
      examples: ['direccion@gasoantonio.com'],
    },
    website: {
      $id: '/properties/website',
      type: 'string',
      title: 'Sitio web',
      default: '',
      examples: ['www.operator.com'],
    },
    email: {
      $id: '/properties/email',
      type: 'string',
      title: 'Email',
      default: '',
      examples: ['email@gmail.com'],
    },
    phone: {
      $id: '/properties/phone',
      type: 'string',
      title: 'Teléfono',
      default: '',
      examples: [' 3 45 65 43'],
    },
    tipo: {
      $id: '/properties/tipo',
      type: 'string',
      title: 'Tipo',
      default: ' ',
      enum: [' ', 'Hospedaje', 'Vuelos', 'Otros servicios'],
      enumNames: [
        'Seleccionar opción ---',
        'Hospedaje',
        'Vuelos',
        'Otros servicios',
      ],
    },
  },
};

const uiSchema = {
  clientId: {
    'ui:widget': 'SelectRemoteWidget',
  },
  email: {
    'ui:widget': 'email',
  },
  password: {
    'ui:widget': 'password',
  },
};

const log = (type) => console.log.bind(console, type);

class OperatorsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      openConfirm: false,
      openSuccess: false,
    };

    console.log('Props', props.match.params);
  }

  componentWillMount() {
    if (this.state.id !== 'create') this.props.findById(this.state.id);
  }

  onSubmit = ({ formData }) => {
    let _this = this;
    console.log('Data submitted: ', formData);
    if (
      formData.password === '' ||
      formData.password === undefined ||
      formData.password === null
    )
      delete formData.password;

    if (this.state.id !== 'create') {
      this.props.update(formData.id, formData).then(function () {
        _this.props.history.push('/admin/config/operators');
      });
    } else {
      this.props.create(formData).then(function () {
        _this.props.history.push('/admin/config/operators');
      });
    }
  };

  onDelete(confirm = false) {
    let _this = this;
    if (confirm) {
      /*this.props.remove(this.state.id).then(function() {
        _this.props.history.push('/admin/config/operators');
      });*/
      this.props.update(this.state.id, { isDeleted: true }).then(function () {
        _this.props.history.push('/admin/config/operators');
      });
    } else {
      this.setState({ openConfirm: true });
    }
  }

  onBlur = (id, value) => {
    console.log('Data submitted: ', this.state.formData);
  };

  render() {
    let { history, Operators } = this.props;
    let { id, openConfirm, openSuccess } = this.state;
    return (
      <div className="main-content">
        {openConfirm && (
          <SweetAlert
            warning
            style={{ display: 'block', marginTop: '-100px' }}
            title="¿Estás Seguro?"
            onConfirm={() => this.onDelete(true)}
            onCancel={() => this.setState({ openConfirm: false })}
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="danger"
            confirmBtnText="Si, borrar!"
            cancelBtnText="Cancelar"
            showCancel
          >
            No podrás desaser está opción!
          </SweetAlert>
        )}

        {openSuccess && (
          <SweetAlert
            success
            style={{ display: 'block', marginTop: '-100px' }}
            title="Listo!"
            confirmBtnBsStyle="info"
            onConfirm={() => this.setState({ openSuccess: false })}
          >
            Se ha actualizado correctamente!
          </SweetAlert>
        )}

        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title={<legend>Editar Operador</legend>}
                content={
                  <div>
                    <Form
                      schema={schema}
                      widgets={widgets}
                      uiSchema={uiSchema}
                      onSubmit={this.onSubmit}
                      onBlur={this.onBlur}
                      formData={Operators.formData}
                      onError={log('errors')}
                    >
                      <div>
                        <Button
                          bsStyle="success"
                          type="submit"
                          className="btn-fill"
                        >
                          Guardar
                        </Button>{' '}
                        <Button
                          bsStyle="default"
                          onClick={() =>
                            history.push('/admin/config/operators')
                          }
                        >
                          Cancelar
                        </Button>
                        <div className="pull-right">
                          {console.log("Permisos: ", auth.getCurrentUser())}
                          {id !== 'create' && (auth.can('support') || auth.can('matriz')) ? (
                            <Button
                              bsStyle="danger"
                              onClick={() => this.onDelete(false)}
                            >
                              Borrar
                            </Button>
                          ) : null}
                        </div>
                      </div>
                    </Form>

                    <div className="clearfix" />
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Operators: state.Operators,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(OperatorsActions, dispatch);
};

const OperatorsConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(OperatorsForm);

export default OperatorsConnect;



// WEBPACK FOOTER //
// ./src/views/Operators/OperatorsForm.jsx